export default "__VITE_ASSET__C4RB7oVF__"